var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "header-carts__item header-cart header-cart--shopping",
      attrs: { href: "/cart/", type: "button" },
    },
    [
      _c("i", {
        staticClass:
          "header-cart__icon header-cart__icon--shopping fa fa-basket-shopping",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "header-cart__text" }, [_vm._v("Корзина")]),
      _vm._v(" "),
      _vm.$cart.counts && _vm.$cart.counts > 0
        ? _c("span", { staticClass: "header-cart__label" }, [
            _vm._v(_vm._s(_vm.$cart.counts)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }